import { $t } from "@/plugins/i18n";

export default [
  {
    path: "/jcb/voucher",
    name: "JcbVoucher",
    component: () => import("../../views/jcb/voucher/index.vue"),
    meta: {
      title: $t("shell.jcb.voucher.banner.title"),
      showLink: false,
      rank: 101
    }
  }
];
